import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import moment from 'moment/moment'

import Container from 'src/ui/molecules/Container'
import Button from 'src/ui/atoms/Button'
import StatusChip from 'src/ui/atoms/StatusChip'
import Table from 'src/ui/organisms/Table'
import ConfirmationModal from 'src/ui/atoms/ConfirmationModal'

import useAirDropsApi from './useAirDropsApi'

const AirDrops = () => {
  const navigate = useNavigate()
  const [airDropsList, setAirDropsList] = useState<[]>([])
  const [itemToRemove, setItemToRemove] = useState<number | null>(null)
  const { getAirdrops, removeAirDrop } = useAirDropsApi()

  const handleGetAirDrops = async () => {
    const res = await getAirdrops()

    if (res) {
      setAirDropsList(res)
    }
  }

  const handleRemove = async () => {
    if (itemToRemove) {
      setItemToRemove(null)
      await removeAirDrop(itemToRemove)

      handleGetAirDrops()
    }
  }

  useEffect(() => {
    handleGetAirDrops()
  }, [])

  const columns = [
    {
      key: 'initiatorAddress',
      name: 'Initiator Address',
      width: '20%',
      render: (data: any) => (
        <span className="cursor-pointer" onClick={() => navigate(`/airdrop/${data.id}`)}>
          {data.initiator}
        </span>
      ),
    },
    {
      key: 'type',
      name: 'Type',
      width: '10%',
      render: (data: any) => data.operation,
    },
    {
      key: 'chain',
      name: 'Chain',
      width: '15%',
      render: (data: any) => <StatusChip name={data.chain} />,
    },
    {
      key: 'network',
      name: 'Network',
      render: (data: any) => data.network,
    },
    {
      key: 'createdAt',
      name: 'Created At',
      render: (data: any) => moment(data.createdAt).format('D MMM YYYY, HH:mm'),
    },
    {
      key: 'updatedAt',
      name: 'Updated At',
      render: (data: any) => moment(data.updatedAt).format('D MMM YYYY, HH:mm'),
    },
    {
      key: 'actions',
      name: 'Actions',
      render: (data: any) => (
        <span
          className="icon-close cursor-pointer text-lg text-red"
          onClick={() => setItemToRemove(data.id)}></span>
      ),
    },
  ]

  return (
    <Container
      title="AirDrops"
      empty={!airDropsList.length ? "You don't have any AirDrops" : ''}
      action={
        <Button size="M" name="Create airdrop" onClick={() => navigate('/airdrop/create')} />
      }>
      {airDropsList.length ? (
        <Table
          columns={columns}
          itemsPerPage={10}
          fetchData={(page: number) => {
            const indexOfLastItem = page * 10
            const indexOfFirstItem = indexOfLastItem - 10

            return {
              data: airDropsList.slice(indexOfFirstItem, indexOfLastItem),
              totalCount: airDropsList.length,
            }
          }}
        />
      ) : (
        ''
      )}
      {itemToRemove && (
        <ConfirmationModal
          title="Are you sure you want to delete this airdrop?"
          actions={
            <>
              <Button
                size="M"
                name="Cancel"
                type="secondary"
                onClick={() => setItemToRemove(null)}
              />
              <Button size="M" name="Delete" onClick={handleRemove} />
            </>
          }
        />
      )}
    </Container>
  )
}

export default AirDrops
